export class Coord {
    x = 0;
    y = 0;
  
    constructor(x = 0, y = 0) {
      this.x = x;
      this.y = y;
    }
  }